import type { DeleteUserGroupUsersMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteUserGroupUsersDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type DeleteUserGroupUsersInput = {
  UserIds: string[];
  UserGroupId: string;
};

export const useDeleteUserGroupUsers = createMutationHook({
  name: 'deleteUserGroupUsers',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.userGroup.deleteUsers.mutationOptions({ onSuccess }),
  mapInput: (variables: DeleteUserGroupUsersInput) => ({
    UserGroupId: variables.UserGroupId,
    UserIds: variables.UserIds,
  }),
  invalidate: (trpc) => [
    trpc.frontend.userGroup.usersByGroupId.queryKey(),
    trpc.frontend.userGroup.userGroupsWithApprovers.queryKey(),
    trpc.frontend.userGroup.userGroupById.queryKey(),
  ],
  mapResponse: (result: {
    affected_rows: number;
  }): DeleteUserGroupUsersMutation => ({
    delete_user_group_user: {
      __typename: 'user_group_user_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: DeleteUserGroupUsersDocument,
  graphqlVariables: (variables: DeleteUserGroupUsersInput) => ({
    ...variables,
  }),
  evictFields: ['user_group_user'],
});
